import { render, staticRenderFns } from "./DialogIdeaType.vue?vue&type=template&id=6c201726&scoped=true"
import script from "./DialogIdeaType.vue?vue&type=script&lang=js"
export * from "./DialogIdeaType.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaType.vue?vue&type=style&index=0&id=6c201726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c201726",
  null
  
)

export default component.exports